module.exports = __webpack_public_path__ + "img/add.089224d1.png";